import { HiOutlineInformationCircle, HiOutlineExclamationCircle, HiOutlineCheckCircle, HiOutlineXCircle } from "react-icons/hi";

export const PageNames = {
    HOME: {name: 'Racetrack', link: '/'},
    OVERVIEW: {name: 'Overview', link: '/overview'},
    STORES: {name: 'Stores', link: '/stores-list'},
    PERFORMANCE: {name: 'Performance', link: '/store-performance'},
    INVENTORY: {name: 'Inventory', link: '/inventory'},
    ALERTS: {name: 'Alerts', link: '/alerts'},
    PROMOTIONS: {name: 'Credits', link: '/credits'},
    PARTNERSHIPS: {name: 'Partnerships', link: '/partnerships'},
    CREATE_PROMOTION: {name: 'Create Memo', link: '/credits/credit-memo'},
    SETTINGS: {name: 'Settings', link: '/settings'},
    USER_MANAGEMENT: {name: 'User Management', link: '/user-management'},
    LOGIN: {name: 'Log In', link: '/'},
    LOGOUT: {name: 'Log Out', link: '/'},
    FINANCIAL: {name: 'Financial', link: '/store-performance'},
    CUSTOMER: {name: 'Customers', link: '/store-performance'}
}

export const Paragraphs = {
    INVENTORY: 'Inventory',
    REPORTS: 'Reports',
    OVERVIEW: 'Overview',
    VIEWMODE: 'Select View Mode',
    PROMOREPORT: 'Campaign Report',
    VENDORDETAILS: 'Vendor Details'
}

export const AlertTypes = {
    WARNING: {
        style: 'warning',
        icon: HiOutlineExclamationCircle
    },
    ERROR: {
        style: 'failure',
        icon: HiOutlineXCircle
    },
    SUCCESS: {
        style: 'success',
        icon: HiOutlineCheckCircle
    },
    INFO: {
        style: 'info',
        icon: HiOutlineInformationCircle
    },
    ALERT: {
        style: 'alert',
        icon: HiOutlineXCircle
    }
}

export const defaultTenantPlaceholder = [{'_tenant_id':0, '_company_name': 'No Company', '_store_name': 'Selected'}]
export const periodOptions = ['month', 'week', 'day']
export const movingAvg = [1,2,3,4,5,6,7]
export const defaultReorderPeriods = [7, 14, 30, 60, 90]

export const defaultPromotionFormData = {
    promotion_id: '',
    promotion_name: '',
    wholesaler_id: '',
    discount_id: '',
    // "All Sales": no discount code; every sale matching the Eligible Products
    // targets earns credit (discount_id is saved as null, targets required).
    all_sales: false,
    docusign_sender_email: '',
    docusign_recipient_email: '',
    docusign_account_id: '',
    credit_id: '',
    credit_value: '',
    credit_value_input: '',
    product_id: '',
    number_of_units: '',
    combined_promotional_price: '',
    start_date: '',
    end_date: '',
    document_id: '',
    filter_id: '',
    target_brand_ids: [],
    target_category_ids: [],
    target_master_category_names: [],
    target_vendor_ids: [],
}

// Display metadata only. The example arithmetic and its result come from the
// promo_credit_example RPC (apply_credit is the single authority for credit
// math, PRD-004 P2.4); see api/endpoints/promotions.js.
export const creditDetails = {
    1: {
        creditUnitName: 'Credit per Unit',
        unit: '$',
        creditVariableName: 'Number of Units',
        method: 'Credit Per Unit * Units',
    },
    2: {
        creditUnitName: 'Guaranteed Margin %',
        unit: '%',
        creditVariableName: 'Number of Units',
        // Mirrors guaranteed_margin() in Postgres: Net Price = Sale Price - Discount
        // (the Combined Promotional Price entered on the form).
        method: '((Net Price * Guaranteed Margin %) - (Net Price - Unit Cost)) * Number of Units',
    },
    3: {
        creditUnitName: 'Percentage Credit from Unit Cost',
        unit: '%',
        creditVariableName: 'Number of Units',
        method: '(Item Cost * Credit % in Decimals) * Units Sold',
    },
    4: {
        creditUnitName: 'Percentage Credit from Unit Price',
        unit: '%',
        creditVariableName: 'Number of Units',
        method: '(Item Sale Price * Credit % in Decimals) * Units Sold',
    },
}


export const defaultVendorSignupState = {
    // User Info
    fist_name: '',
    last_name: '',
    password: '',
    target_email: '',
    invite_token: '',
    confirmPassword: '',
    // Vendor Info
    legalEntityName: '',
    dba: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: ''
}
